import { getAltFromSrc } from 'utils/helpers/getAltFromSrc/getAltFromSrc'

import s from './HeaderButton.module.scss'

interface HeaderButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string
  buttonType?: 'default' | 'transparent'
}

export const HeaderButton = ({ icon, style, buttonType = 'default', ...other }: HeaderButtonProps) => {
  return (
    <button
      className={s.button}
      {...other}
      style={{ ...style, border: buttonType === 'default' ? '1px solid #d9d9d9' : undefined }}
    >
      <img src={icon} alt={getAltFromSrc(icon)} className={s.icon} />
    </button>
  )
}
